module.exports = __webpack_public_path__ + "static/media/logo-issa.cd526d32.png";